class DiagnosticHub extends Diagnostic {
  constructor() {
    super();

    // Register events once in constructor
    this._registerEvents();
  }
  init() {
    //Rewrite needed properties for mini diagnostic
    this.template = "mini";
    this.initialQuestionHandle = null;
    this.localStorageKey = {
      progress: 'diagnostic-hub-progress',
      products: 'diagnostic-hub-products'
    };
    this.selections = document.getElementById('diag-selections') ? JSON.parse(document.getElementById('diag-selections').innerText) : {};

    //Display the results if the view is hub-diag-result
    if (window.location.href.indexOf('view=hub-diag-result') !== -1) {
      this.displayResults();
      return;
    }
    this.diagElem = document.querySelector('.mini-diag');
    this.customerId = this.diagElem.getAttribute('data-customer-id') ? parseInt(this.diagElem.getAttribute('data-customer-id')) : null;
    this.initialQuestionHandle = "q3-chamboulement-hormonal";
    this.needQuestionHandle = "q5-besoin-principal";
    this.needAnswerHandle = this.diagElem.getAttribute('data-need-answer');
    localStorage.removeItem(this.localStorageKey.products);
    /* console.log("initialQuestionHandle", this.initialQuestionHandle); */

    this.instanciateQuestion(this.initialQuestionHandle);
  }
  instanciateQuestion(handle) {
    /* console.log("instanciateQuestion", handle); */

    // Listen for the 'first-hub-question-answered' event
    this.diagElem.addEventListener('first-hub-question-answered', event => {
      // You can handle the event here, for example:
      // console.log('First hub question answered:', event.detail);
      window.dataLayer = window.dataLayer || [];
      const alreadyPushed = window.dataLayer.some(e => e.event === 'start_diagnostic_ta' && e.diagnostic_name === 'hub_diagnostic');
      if (!alreadyPushed) {
        window.dataLayer.push({
          event: 'start_diagnostic_ta',
          diagnostic_name: 'hub_diagnostic'
        });
      }

      // console.log("dataLayer", window.dataLayer);
    });
    if (this.customerDataQuestionHandles.includes(handle)) {
      // Skip customer data questions for mini diagnostic
      const next_question = this._cachedQuestion[handle].json.next_question;
      if (next_question != null) {
        this.instanciateQuestion(next_question);
      } else {
        this.submitDiagnostic();
      }
    } else if (handle === this.needQuestionHandle) {
      // Skip and auto-answer need question for mini diagnostic
      const next_question = this._cachedQuestion[handle].json.answers.find(answer => answer.value === this.needAnswerHandle).next_question;
      this.instanciateQuestion(next_question);
      this.data.answers.push({
        "handle": this.needQuestionHandle,
        "answer": this.needAnswerHandle
      });
    } else {
      this.activeQuestion = new Question(handle, this);
    }

    // Hide or show actions buttons on mini diag template
    let actionsButtons = document.querySelector('.mini-diag__action');
    if (actionsButtons) {
      if (this.initialQuestionHandle != handle) {
        actionsButtons.classList.add('is-visible');
      } else {
        actionsButtons.classList.remove('is-visible');
      }
    }

    // Save progress and data to local storage, except for the initial question
    if (handle !== this.initialQuestionHandle) {
      this._saveProgressToLocalStorage();
    }
  }
  async submitDiagnostic() {
    const products = await this._getSelectionProducts();
    let resultUrl = window.location.pathname + "?view=hub-diag-result";
    let productsIds = '&products_ids=';
    Object.entries(products).forEach(element => {
      productsIds += element[1].id + ',';
    });
    productsIds = productsIds.slice(0, -1);
    resultUrl += productsIds;
    localStorage.setItem(this.localStorageKey.products, JSON.stringify(products));
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'submit_diagnostic_ta',
      diagnostic_name: 'hub_diagnostic'
    });

    // console.log("dataLayer", window.dataLayer);

    window.location.href = resultUrl;
  }
  displayResults() {
    let productsList = document.querySelector('.collection-hub-result .product-list__inner');
    let products = document.querySelectorAll('.collection-hub-result .product-item');
    let productsArray = Array.from(products);
    let productsToDisplay = JSON.parse(localStorage.getItem(this.localStorageKey.products));
    let productsToDisplayArray = Object.values(productsToDisplay);

    // Add loader
    productsList.classList.add('is-loading');

    // Filter products and show only the ones that are in the result diag
    let productsDiplayedNumber = 0; // It will be used to hide text in the product grid when there is less than 3 products to display
    productsToDisplayArray.forEach(product => {
      let productId = product.id;
      let productToDisplay = productsArray.find(p => p.getAttribute("data-id") == productId);
      if (productToDisplay) {
        // Inject text description into the product item
        let newParagraph = document.createElement('p');
        newParagraph.classList.add('text');
        newParagraph.textContent = product.text;
        productToDisplay.querySelector('.product-item__info .product-item-meta').appendChild(newParagraph);

        // Add class to the product item
        let itemClass = "item-" + productsDiplayedNumber;
        productToDisplay.classList.add(itemClass);
        productToDisplay.classList.add("product-item__diag-result");
        productsDiplayedNumber++;
      }
    });

    // Remove all products that are not in the result diag
    let productsToHide = document.querySelectorAll('.collection-hub-result .product-item:not(.product-item__diag-result)');
    productsToHide.forEach(product => {
      product.remove();
    });

    // FEATURED COLLECTIONS SECTION
    // There are 2 featured collections sections in the page, one for the result diag and one for the no result diag
    let featuredCollections = document.querySelectorAll(".shopify-section--featured-collections")[0]; // Hide it when there is no result
    let featuredCollectionsForNoResult = document.querySelectorAll(".shopify-section--featured-collections")[1]; // Show it when there is no result

    if (featuredCollectionsForNoResult) {
      featuredCollectionsForNoResult.classList.add("hide");
    }

    // Display no result message if there is no product to display or if there is no product after filtering
    let noResultDiv = document.querySelector('.collection-hub-result__no-result');
    let productsDiplayed = document.querySelectorAll('.collection-hub-result .product-item');
    if (productsToDisplayArray.length == 0 || productsDiplayed.length == 0) {
      productsList.remove();
      noResultDiv.classList.remove("hide");
      featuredCollections.classList.add("hide");
      if (featuredCollectionsForNoResult) {
        featuredCollectionsForNoResult.classList.remove("hide");
      }
    }

    // Remove loader
    productsList.classList.remove('is-loading');

    // If there is only one product to display, center it on mobile
    if (productsDiplayed.length === 1) {
      productsDiplayed[0].classList.add('product-item--full-width');
    }

    // Hide secondary objective text when there is less than 3 products in diag result
    let secondaryObjectiveText = document.querySelector('.product-list__secondary-objective');
    if (productsDiplayedNumber < 3 && secondaryObjectiveText) {
      secondaryObjectiveText.remove();
    }

    // SECTION FEATURED COLLECTION
    // Display current collection products but not the product which are in result diag
    let productsInFeaturedCollections = document.querySelectorAll('.featured-collections .product-item');
    productsInFeaturedCollections.forEach(product => {
      if (productsToDisplayArray.length == 0) {
        let productsDiplayed = document.querySelectorAll('.featured-collections .product-item');
        if (productsDiplayed.length > 3) {
          // Delete the rest of the products when 3 products are displayed 
          product.remove();
        }
      } else {
        let productId = product.getAttribute("data-id");
        let productToHide = productsToDisplayArray.find(p => p.id == productId); // Remove product if it is in the result diag

        if (productToHide) {
          product.remove();
        } else {
          // Add data attribute when product is displayed in the section
          product.setAttribute('data-not-in-diag', 'true');
        }

        // When 3 or more products are displayed, all the others are removed
        let productsNotInDiag = document.querySelectorAll('.featured-collections .product-item[data-not-in-diag="true"]');
        if (productsNotInDiag.length > 3) {
          product.remove();
        }
      }
    });
  }
  _registerEvents() {
    let self = this;
    document.querySelector('.mini-diag').addEventListener('click', event => {
      if (event.target.classList.contains('restart-button')) {
        self.init();
      }
    });
    document.querySelector('.back-button')?.addEventListener('click', () => {
      this.activeQuestion.previousQuestion();
    });
  }
}